/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCurrencyMoney = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M23 4v16H1V4zM3 16.171V18h1.83A3.016 3.016 0 0 0 3 16.171zm14.101-10.17H6.9A5.015 5.015 0 0 1 3 9.899v4.202A5.015 5.015 0 0 1 6.9 18h10.2a5.015 5.015 0 0 1 3.9-3.9V9.899a5.015 5.015 0 0 1-3.9-3.898zM21 16c-.851.302-1.526 1.148-1.828 2H21zm-9-8c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm0 2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm9-4h-1.828c.302.852.977 1.698 1.828 2zM4.83 6H3v1.829A3.016 3.016 0 0 0 4.83 6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCurrencyMoney as CurrencyMoney };
